module.exports = __webpack_public_path__ + "img/subcurve4.bc770df1.svg";